import { httpRequest } from "../../http";
import { MediaFile } from "@models/mediaFile.model";
import type { Ad } from "@models/Ad.model";

export interface ResolvedAdContent {
    ad: Ad;
    preview: MediaFile | null;
    media: MediaFile | null;
}

export interface ResolveAdsOut {
    /** A null entry means the ad resolved to nothing — distinct from an absent
     *  entry, which means it has not been resolved yet. */
    resolved: Record<number, ResolvedAdContent | null>;
}

/** Raw response from the resolve endpoint (now returns full Ad per ad id) */
export type ResolveAdsRawOut = Record<number, Ad | null>;

export class CommandResolveAds {
    async run(adIds: number[]): Promise<ResolveAdsRawOut> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/resolve/`;
        try {
            const response = await httpRequest<ResolveAdsRawOut>(url, {
                method: "POST",
                body: { ad_ids: adIds },
            });
            return response;
        } catch (error) {
            console.error("Error resolving ads:", error);
            throw error;
        }
    }
}
